export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      removeHref(data, widgetName);
      $(window).load(function () {
        var hotButtonsTop = $('#hotButtons').offset().top + ($('#hotButtons').innerHeight() / 3.5);
        var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();

        // function animateHotButtons(val1, val2) {
        //   if (val2 > val1) {
        //     $('#hotButtons').addClass('in-view');
        //   }
        // }

        // if (!$('#hotButtons').hasClass('in-view')) {
        //   animateHotButtons(hotButtonsTop, bottomOfScreen);
        // }

        // $(window).on('scroll', function() {
        //   if (!$('#hotButtons').hasClass('in-view')) {
        //     var hotButtonsTop = $('#hotButtons').offset().top + ($('#hotButtons').innerHeight() / 3.5);
        //     var bottomOfScreen = $(window).scrollTop() + $(window).innerHeight();
        //     animateHotButtons(hotButtonsTop, bottomOfScreen);
        //   }
        // });

      });
      $('#hotButtons').attr({
        "data-aos": "fade-up",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "800",
        "data-aos-delay": "200",
        "data-aos-once": "true",
        "data-aos-offset": "250"
      })
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 9,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: true
  });
}

// Removes href attribute if the button has no link
function removeHref(data, widgetName) {
  $(`#${widgetName} .card-widget-item`).each(function (x, item) {
    $(item).removeAttr('target');
    if (data.items[x]?.URL === null) {
      $(item).removeAttr('href');
    }
  });
}
  